var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "col-10 offset-1" }, [
      _c("table", { staticClass: "table table-striped" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.highlights, function(h) {
            return _c("tr", { key: h.dt + h.state }, [
              _c("td", [_vm._v(_vm._s(h.dt))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(h.state))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(h.generated))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(h.cancelled))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(h.noPartB))])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-10 offset-1" }, [
      _c("h2", { staticClass: "form-head" }, [_vm._v("Dashboard")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-dark" }, [
      _c("tr", [
        _c("th", [_vm._v("Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("State")]),
        _vm._v(" "),
        _c("th", [_vm._v("Generated")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cancelled")]),
        _vm._v(" "),
        _c("th", [_vm._v("NO Part-B")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18713d1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18713d1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EWBHomePage.vue
// module id = null
// module chunks = 